import {React, useEffect, useState} from 'react'
import './style.css'
import { getTotalUserCount } from '../../../services/Admin';
import Loader from "../../components/loader/Loader";
import Loader2 from "../../components/loader/Loader2";

function Dashboard() {

  const [userCount, setUserCount] = useState(0)
  const [isPending, setIsPending] = useState(false); 
  const [isLoading, setIsloading] = useState(false); 


  const fetchTotalUserCount = async () => {
    try {
      setIsloading(true);
      const response = await getTotalUserCount();
      setUserCount(response && response.totalUserCount ? response.totalUserCount : 0);

    } catch (error) {
      console.error(error);
      setUserCount(0);
    } finally {
      setIsloading(false);
    }
  }


  useEffect(() => {
    fetchTotalUserCount();

  }, [])
    

  return (
    <>
    {isLoading ? (
      <Loader />
    ) : (
    <div>
      <h1 className="main-heading">Dashboard</h1>
      <br />
      <br />
      <div className='admin-dashboard'>
        <div className='ad-da-first'>
          <div className='ad-fa-fi-item'>
            <h2>Total User</h2>
            <h1>{userCount || 0}</h1>
          </div>
        </div>
      </div>

    </div>
    )}
    </>
  )
}

export default Dashboard
